import * as styles from "./PaginationPages.css";

import type { ReactNode } from "react";

import { Icon } from "@frontend/components/atoms/Icon";

import type { PaginationPageListProps } from "./Pagination.types";
import { PaginationPageButton } from "./PaginationPageButton";
import { ELLIPSIS_SLOT } from "./constants";
import { ELLIPSIS } from "./getPaginationRange";

export function PaginationPages({
  range,
  page,
  size,
  disabled,
  onPageChange,
  onPagePrefetch,
}: PaginationPageListProps): ReactNode {
  return range.map((item, index) =>
    item === ELLIPSIS ? (
      <span
        key={`ellipsis-${index}`}
        data-slot={ELLIPSIS_SLOT}
        className={styles.ellipsis({ size })}
        aria-hidden="true"
      >
        <Icon name="MoreHorizontal" size={size} />
      </span>
    ) : (
      <PaginationPageButton
        key={item}
        page={item}
        current={item === page}
        size={size}
        disabled={disabled}
        onPageChange={onPageChange}
        onPagePrefetch={onPagePrefetch}
      />
    ),
  );
}
